<template>
  <v-card
    width="70%"
    min-width="500px"
    class="mx-auto "
    v-bind:class="{ fnishedSwitched: question.process == 'finished' }"
    raised
  >
    <v-toolbar color="#546E7A" dark
      >Question # {{ question.number }}
    </v-toolbar>

    <v-card-text class="px-10"
      ><h4>
        {{ question.question }}
      </h4>
      <v-divider :inset="inset"></v-divider>

      <div class="px-10" v-if="question.type == 'mc'">
        <v-radio-group>
          <v-radio
            v-for="(choice, index) in question.choices"
            :key="index"
            :label="` ${choice}`"
            :value="{ choice }"
            align="center"
            justify="center"
          ></v-radio>
        </v-radio-group>
      </div>

      <v-from class="px-10" v-if="question.type == 'cr'">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Type Your Answer Here"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-from>

      <v-container fluid class="px-10" v-if="question.type == 'lg'">
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              filled
              auto-grow
              label="type your long answer here"
              rows="4"
              row-height="30"
              shaped
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- <v-row>
      <v-switch v-model="showHint" label="Click to See Hint(Lose Scores)">
      </v-switch>
      <v-input
        hint=""
        persistent-hint
        :messages="messages"
      ></v-input>
    </v-row> -->
    <v-row class="pr-10 mr-10 justify-space-around">
      <v-col cols="6" sm="1" md="1" lg="1">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-switch
                v-model="question.marked"
                label="Mark"
                value="marked"
                color="red darken-3"
                v-on="on"
              ></v-switch>
            </div>
          </template>
          <span>You can mark it now and solve it later.</span>
        </v-tooltip>
      </v-col>

      <v-col cols="6" sm="1" md="1" lg="1">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-switch
                v-model="question.process"
                label="Finish"
                value="finished"
                color="green darken-3"
                v-on="on"
              ></v-switch>
            </div>
          </template>
          <span>Save and Next</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    showHint: false,
  }),
  props: ["question"],
  // computed: {
  //   messages() {
  //     return this.showHint ? this.question.hint : undefined;
  //   },
  // },
  methods: {},
};
</script>

<style scoped>
.hintText {
  color: white;
}

.hintText:hover {
  color: #003399;
}

.fnishedSwitched {
  background-color: Gainsboro;
  margin: auto;
}

.markedSwitched {
  background-color: orangered;
  margin: auto;
}
</style>
